export const BUSINESS_ENTITY_TYPES = [
  'PRIVATE_HOME',
  'FAMILY',
  'HOME_CARE_PROVIDER',
  'NURSING_HOME',
  'ASSISTED_LIVING_FACILITY',
  'SENIOR_CARE_AGENCY',
  'NONPROFIT',
  'BUSINESS',
  'OTHER',
];

export const BUSINESS_STATUSES = [
  'DRAFT',
  'ACTIVE',
  'PENDING_REVIEW',
  'APPROVED',
  'SUSPENDED',
  'DELETED',
];

export const BUSINESS_LOCATION_STATUSES = [
  'ACTIVE',
  'INACTIVE',
  'SUSPENDED',
  'DELETED',
];

export const BUSINESS_USER_ROLES = [
  'OWNER',
  'ADMIN',
  'MANAGER',
  'STAFF',
  'CONTACT_PERSON',
  'OTHER',
];

export const BUSINESS_USER_STATUSES = [
  'ACTIVE',
  'PENDING',
  'SUSPENDED',
  'REMOVED',
];

export const SERVICE_CATEGORIES = [
  'ELDERLY_CARE',
  'HOME_CARE',
  'NURSING_HOME_SUPPORT',
  'TRANSPORTATION',
  'FAMILY_SUPPORT',
  'FACILITY_SUPPORT',
  'COMPANION_CARE',
  'HOUSEKEEPING',
  'MEDICATION_SUPPORT',
  'MEAL_SUPPORT',
  'SPECIAL_NEEDS_SUPPORT',
  'RESTAURANT',
  'FOOD_SERVICE',
  'DELIVERY',
  'CLEANING',
  'HOTEL',
  'HOSPITALITY',
  'SCHOOL',
  'EDUCATION',
  'CHILDCARE',
  'RETAIL',
  'GROCERY',
  'HEALTHCARE',
  'BEAUTY_AND_WELLNESS',
  'FITNESS',
  'MAINTENANCE',
  'REPAIR',
  'SALON',
  'SECURITY',
  'EVENT_SUPPORT',
  'PROFESSIONAL_SERVICES',
  'NONPROFIT_SERVICES',
  'OTHER',
];

export const formatEnumLabel = (value: string): string => {
  if (!value) return '';
  return String(value)
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (m) => m.toUpperCase());
};
